import React, { useState } from 'react';
import Modal from '../Modal/Modal';
import Button from '../Button/Button';
import Select from '../Select/Select';
import Radio from '../Radio/Radio';
import Checkbox from '../Checkbox/Checkbox';
import styles from './ExportDialog.module.css';

const ExportDialog = ({
    show,
    onClose,
    onExport,
    loading = false,
    availableFormats = ['GeoJSON', 'KML', 'SHP', 'CSV', 'PDF'],
    availableLayers = ['plots', 'buildings', 'roads', 'markers']
}) => {
    const [format, setFormat] = useState('GeoJSON');
    const [layers, setLayers] = useState(availableLayers);
    const [includeMetadata, setIncludeMetadata] = useState(true);
    const [coordinateSystem, setCoordinateSystem] = useState('wgs84');

    const formatOptions = availableFormats.map(f => ({ value: f, label: f }));

    const coordinateOptions = [
        { value: 'wgs84', label: 'WGS 84 (EPSG:4326)' },
        { value: 'pz90', label: 'ПЗ-90 (Российская система)' },
        { value: 'utm', label: 'UTM' }
    ];

    const handleLayerChange = (layer, checked) => {
        setLayers(prev =>
            checked
                ? [...prev, layer]
                : prev.filter(l => l !== layer)
        );
    };

    const handleExport = () => {
        if (onExport) {
            onExport({
                format,
                layers,
                includeMetadata,
                coordinateSystem
            });
        }
    };

    const isExportDisabled = layers.length === 0 || loading;

    return (
        <Modal
            show={show}
            onClose={onClose}
            title="Экспорт данных"
            size="md"
            footer={
                <>
                    <Button variant="secondary" onClick={onClose} disabled={loading}>
                        Отмена
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleExport}
                        loading={loading}
                        disabled={isExportDisabled}
                    >
                        Экспорт
                    </Button>
                </>
            }
        >
            <div className={styles.content}>
                {/* Формат */}
                <div className={styles.field}>
                    <label className={styles.label}>Формат файла</label>
                    <Select
                        options={formatOptions}
                        value={format}
                        onChange={setFormat}
                        placeholder="Выберите формат"
                    />
                </div>

                {/* Слои */}
                <div className={styles.field}>
                    <label className={styles.label}>Слои для экспорта</label>
                    <div className={styles.layerList}>
                        {availableLayers.map(layer => (
                            <div key={layer} className={styles.layerItem}>
                                <Checkbox
                                    id={`layer-${layer}`}
                                    label={layer}
                                    checked={layers.includes(layer)}
                                    onChange={(checked) => handleLayerChange(layer, checked)}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Система координат */}
                <div className={styles.field}>
                    <label className={styles.label}>Система координат</label>
                    <Select
                        options={coordinateOptions}
                        value={coordinateSystem}
                        onChange={setCoordinateSystem}
                    />
                </div>

                {/* Дополнительные опции */}
                <div className={styles.field}>
                    <div className={styles.optionsGroup}>
                        <Radio
                            name="export-type"
                            label="Экспортировать только выбранные объекты"
                            checked={false}
                            onChange={() => {}}
                        />
                        <Radio
                            name="export-type"
                            label="Экспортировать все объекты"
                            checked={true}
                            onChange={() => {}}
                        />
                    </div>
                </div>

                <div className={styles.field}>
                    <Checkbox
                        id="include-metadata"
                        label="Включить метаданные (описание, атрибуты)"
                        checked={includeMetadata}
                        onChange={setIncludeMetadata}
                    />
                </div>

                {/* Информация */}
                <div className={styles.info}>
                    <p>
                        Будут экспортированы {layers.length} сло{layers.length === 1 ? 'й' : layers.length < 5 ? 'я' : 'ев'}.
                        {includeMetadata && ' Метаданные будут включены.'}
                    </p>
                </div>
            </div>
        </Modal>
    );
};

export default ExportDialog;
